import { css } from '@portal/styled-system/css'
import type { SystemStyleObject } from '@portal/styled-system/types'

import { isPlatformEnabled } from '@/shared/config'

import { AUTH_CARD_BUTTON_WIDTH } from './constants'
import { FacebookButton as FacebookLoginButton } from './facebook'
import { GoogleLoginButton } from './google/login'
import { YahooLoginButton } from './yahoo/login'

type LoginButtonsProps = {
    showFbButton?: boolean
    styles?: SystemStyleObject
}

export function LoginButtons({ showFbButton = true, styles }: LoginButtonsProps) {
    const width = AUTH_CARD_BUTTON_WIDTH

    return (
        <div
            className={css({ display: 'flex', flexDir: 'column', alignItems: 'center', gap: '2' }, styles)}
            // biome-ignore lint/nursery/noInlineStyles: width is a runtime value, Panda extracts classes at build time
            style={{ width }}
        >
            {isPlatformEnabled('gg') && <GoogleLoginButton width={width} />}

            {isPlatformEnabled('yahoo') && <YahooLoginButton />}

            {showFbButton && isPlatformEnabled('fb') && <FacebookLoginButton />}
        </div>
    )
}
